import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { AiInTriageThreeArmVariation, useFlags } from '@lyrahealth-inc/shared-app-logic'

import {
  getIsChildSearchForCare,
  getSelectedSearchPrimaryNeed,
  getSelectedSearchPrimaryNeedMultiselect,
} from '../../features/triage/data/triageSelectors'

/*
  Get's the correct questionnaire value for primary need based on the canSelectMultiplePrimaryNeeds LD flag
*/
export const useGetPrimaryNeedWords = (): string[] | undefined => {
  const { canSelectMultiplePrimaryNeeds, isAiInTriageEnabledThreeArm } = useFlags()

  const singlePrimaryNeed = useSelector(getSelectedSearchPrimaryNeed)
  const multiPrimaryNeed = useSelector(getSelectedSearchPrimaryNeedMultiselect)
  const isChildSearch = useSelector(getIsChildSearchForCare)

  const primaryNeed = useMemo(() => {
    if (
      (canSelectMultiplePrimaryNeeds ||
        isAiInTriageEnabledThreeArm === AiInTriageThreeArmVariation.FREE_TEXT_ONLY ||
        isAiInTriageEnabledThreeArm === AiInTriageThreeArmVariation.FREE_TEXT_AI_RESPONSES) &&
      multiPrimaryNeed &&
      !isChildSearch
    ) {
      return multiPrimaryNeed?.toJS()
    } else if (singlePrimaryNeed) {
      return [singlePrimaryNeed]
    } else {
      return undefined
    }
  }, [canSelectMultiplePrimaryNeeds, isAiInTriageEnabledThreeArm, isChildSearch, multiPrimaryNeed, singlePrimaryNeed])

  return primaryNeed
}
